import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

const NotFound: React.FC = () => {

  return (
    <>
      <Box sx={{ padding: 1, marginTop: 4, textAlign: "center" }}>
        <Typography variant="h3">Sorry, Page Not Found</Typography>
        <Button variant="contained" color="primary" href="/">
          Go to Home
        </Button>
      </Box>
    </>
  );
};

export default NotFound;